module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DARKNESS RISING")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc11",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/chapter3d#hc3",
      "id": "ch3"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0007-02-1"
    }
  }, [_c('span', [_vm._v("Conceiving of and writing a book takes a leap of faith. Thank you to all the readers of the East Salem novels who have taken that leap of faith with me. I am humbled and inspired.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-02-2"
    }
  }, [_c('span', [_vm._v("Thank you, O’Reilly, from Wiehl. And Roger Ailes, who took a chance on hiring a certain legal analyst. And Dianne Brandi, whose judgment is infallible.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-02-3"
    }
  }, [_c('span', [_vm._v("Thank you to Pete’s lovely wife, Jen, and son, Jack, for all their patience. And to Bob Roe, for his keen eye and pen.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-02-4"
    }
  }, [_c('span', [_vm._v("Thank you to the amazing team at Thomas Nelson, including Daisy Hutton, senior vice president and publisher (a true visionary); Ami McConnell, senior acquisitions editor (and compatriot); L.B. Norton (so appreciate your work and sense of humor); Amanda Bostic, acquisitions editor (“brilliant” should be added to her title); Natalie Hanemann, senior editor; Becky Monds, associate editor (and a stellar human being); Jodi Hughes, editorial assistant. In marketing, thank you, Eric Mullett, marketing director; Ashley Schneider, marketing specialist; Ruthie Dean, publicity coordinator; Katie Bond, publicity manager (and one of the finest people I know); and Kristen Vasgaard, packaging manager (who is a creative genius). Your spirit and enthusiasm is wonderfully infectious. And a special thank-you to the awe-inspiring Allen Arnold, my friend always.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-02-5"
    }
  }, [_c('span', [_vm._v("Thank you to our book agents, Todd Shuster and Lane Zachary of the Zachary, Shuster, and Harmsworth Literary Agency. We couldn’t have done this without you!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-02-6"
    }
  }, [_c('span', [_vm._v("All of the mistakes are ours. All the credit is theirs. Thank you!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6044f85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 78
// module chunks = 0